(function () {
  'use strict';
  if (window.dsrcvAnnouncementBar) return;
  var visitKey = 'dsrcv-announcement-visit-v1';

  function emptyDeliveryMessage(api) {
    if (!api || (api.isLoading && api.isLoading()) ||
        (api.isProgressLoading && api.isProgressLoading())) return null;
    var progress = api.getProgress ? api.getProgress() : api.getQuote && api.getQuote();
    var country = String(window.Shopify && window.Shopify.country || '').toUpperCase();
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (!progress || progress.available !== true || progress.reason === 'free_threshold_not_unique' ||
        progress.countryCode !== country || progress.currency !== currency || progress.subtotalCents !== 0 ||
        !Number.isSafeInteger(progress.freeThresholdCents) || progress.freeThresholdCents <= 0 ||
        progress.remainingCents !== progress.freeThresholdCents) return null;
    var amount = Math.ceil(progress.freeThresholdCents / 100);
    var formatted;
    try {
      formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currencyDisplay: 'narrowSymbol', currency: currency, minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    } catch (error) { return null; }
    return 'Free ' + (country === 'GB' ? 'UK ' : '') + 'delivery from ' + formatted;
  }

  function mount(bar) {
    if (bar.dataset.announcementReady) return;
    bar.dataset.announcementReady = 'true';
    var arrivalChecked = false;
    function update() {
      var campaign = bar.dataset.fsbCampaign === 'true';
      bar.querySelectorAll('.AnnouncementBar__CampaignLabel').forEach(function (label) { label.remove(); });
      if (!campaign) bar.querySelectorAll('.FSBExtension__Slide:not(.FSBExtension__Slide--dynamic) .FSBExtensionSlideContent').forEach(function (node) {
        if (/^Free returns$/i.test(node.textContent.trim())) node.textContent = 'Free UK returns';
      });
      var delivery = emptyDeliveryMessage(window.__FreeShippingBarAPI);
      if (delivery) bar.querySelectorAll('[data-role="dynamic-message"]').forEach(function (node) {
        if (node.textContent !== delivery) node.textContent = delivery;
      });
      var initial = bar.querySelector('.FSBExtension__Slides.initialized .FSBExtension__Slide.is-active .FSBExtensionSlideContent');
      if (!arrivalChecked && initial) {
        arrivalChecked = true;
        var firstVisit = false;
        try {
          firstVisit = !window.sessionStorage.getItem(visitKey);
          window.sessionStorage.setItem(visitKey, 'seen');
        } catch (error) { return; }
        if (firstVisit && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && initial.animate) {
          initial.animate([{ opacity: 0, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], {
            duration: 650, easing: 'cubic-bezier(.22,1,.36,1)'
          });
        }
      }
    }
    var observer = new MutationObserver(update);
    observer.observe(bar, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    document.addEventListener('dsrcv:shipping-quote-updated', update);
    document.addEventListener('shopify:section:unload', function unload(event) {
      if (!event.target.contains(bar) && bar.isConnected) return;
      observer.disconnect();
      document.removeEventListener('dsrcv:shipping-quote-updated', update);
      document.removeEventListener('shopify:section:unload', unload);
    });
    update();
  }
  function mountAll() { document.querySelectorAll('.FreeShippingBar').forEach(mount); }
  window.dsrcvAnnouncementBar = { mount: mountAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
})();
